import { useLocation } from 'react-router-dom';
import { getRouteConfig } from '../config/routeTitles';

/**
 * Custom hook for route-based title management
 * @returns {object} - Route configuration with title info
 */
export const useRouteTitle = () => {
  const { pathname } = useLocation();

  return getRouteConfig(pathname);
};
